module.exports = __webpack_public_path__ + "img/horizontal_3_1_r_pp1_6000.73d92be5.png";